(function () {
  /**
   * @ngdoc provider
   * @name apiInterceptorReady
   * @description defines apiReady provider to configure api endpoints
   */
  angular.module('app.core.api.interceptor.ready').provider('apiInterceptorReady', provider);

  /* @ngInject */
  function provider(
    $httpProvider,
    _,
    apiReadyProvider,
    coldCacheResponseInterceptorProvider,
    configurationReadyProvider
  ) {
    const ngInjector = angular.injector(['ng']);
    const $q = ngInjector.get('$q');
    const configDeferred = $q.defer();

    this.$get = $get;
    this.configure = configure;
    this.whenConfigReady = whenConfigReady;

    /////////

    function configure() {
      $httpProvider.interceptors.push('coldCacheResponseInterceptor');

      $q.all([apiReadyProvider.whenConfigReady(), configurationReadyProvider.whenConfigReady()])
        .then((results) => {
          coldCacheResponseInterceptorProvider.configure({
            whitelist: getCacheCanBeColdWhitelist(results[1]),
          });

          configDeferred.resolve();
        })
        .catch(configDeferred.reject);

      return configDeferred.promise;
    }

    function whenConfigReady() {
      return configDeferred.promise;
    }

    function $get() {
      const service = {
        whenRunReady: whenConfigReady,
      };
      return service;
    }

    ////////

    function getCacheCanBeColdWhitelist(config) {
      return _(config.services).filter({cacheCanBeCold: true}).map('url').uniq().value();
    }
  }
})();
